export class JsonStorage {
  constructor(storage) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "brick-next-";
    this.storage = storage;
    this.prefix = prefix;
  }
  setItem(name, value) {
    this.storage.setItem(this.prefix + name, JSON.stringify(value));
  }
  getItem(name) {
    return JSON.parse(this.storage.getItem(this.prefix + name));
  }
  removeItem(name) {
    return this.storage.removeItem(this.prefix + name);
  }
  clear() {
    return this.storage.clear();
  }
}
//# sourceMappingURL=JsonStorage.js.map